<template>
  <section class="mb-0 auto-height" id="case-list">
      <div class="container">
        <h3 class="text-center mb-0">熱銷建案</h3>
        <br>
        <swiper v-if="cases.length>0" :options="swiperOption" :key="display">
          <swiper-slide v-for="(c, i) in cases" :key="i">
            <a @click="showCaseIdx=i;showModal=true;">
              <CaseListCard :c="c"/>
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z"></svg></div>
          <div class="swiper-button-next" slot="button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z"></svg></div>
        </swiper>
        <p v-else>※ 敬請期待</p>
      </div>
      <CaseListModal v-if="showCaseIdx < cases.length" :c="cases[showCaseIdx]" :class="{noshow: !showModal}" @close="showModal=false" />
  </section>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import CaseListCard from './CaseListCard.vue'
import CaseListModal from './CaseListModal.vue'

export default {
  name: 'CaseList',
  components: {
    swiper,
    swiperSlide,
    CaseListCard,
    CaseListModal
  },
  props: {
    cases: Array,
  },
  data() {
    return {
      showModal: false,
      showCaseIdx: Infinity,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 35,
        slidesPerGroup: 2,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          992: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        }
      }
    }
  },
  watch: {
    cases(newVal, oldVal) {
      const params = this.getAllParams(window.location.href);
      if (params.case) {
        for (let i = 0; i < this.cases.length; i++) {
          if (this.cases[i].id === +params.case) {
            this.showCaseIdx = i;
            this.showModal = true;
            break;
          }
        }
      }
    }
  },
  methods: {
    getAllParams(url) {
      let params = {};
      let parser = document.createElement('a');
      parser.href = url;
      let query = parser.search.substring(1);
      let vars = query.split('&');
      for (let i = 0; i < vars.length; i += 1) {
        let pair = vars[i].split('=');
        if (pair[0] !== '') {
          params[pair[0]] = decodeURIComponent(pair[1]);
        }
      }
      return params;
    }
  }
}
</script>

<style scoped>
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color:  rgba(11, 109, 49, 0.842);;
}
.swiper-button-next, .swiper-button-prev {
    background-image: none;
    fill: rgba(11, 109, 49, 0.842);
}
</style>